import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssetUIModel, AssetsGenerateUrlService, ClientCoreModule } from '@thehubz/client/core';
import { CreateAssetDto } from '@thehubz/client/data-access-api';
import { Observable, map } from 'rxjs';
import { ImageZoomRoutingPaths } from '../../../image-zoom-routing-paths.enum';
import { ZoomImageDirective } from './zoom-image.directive';

@Component({
  selector: 'thehubz-asset-image',
  templateUrl: './asset-image.component.html',
  styles: [
    `
      .media-asset-visualizer {
        position: relative;
      }

      .zoomed-image {
        position: absolute;
        width: 32vw;
        height: 50vh;
        min-width: 250px;
        min-height: 250px;
        max-width: 600px;
        max-height: 500px;
        top: 0;
        left: 100%;
        border: 1px solid #ccc;
        background-repeat: no-repeat;
        background-color: #fff;
        z-index: 100;
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, ClientCoreModule, ZoomImageDirective],
})
export class AssetImageComponent {
  @Input() set asset(asset: AssetUIModel) {
    this._asset = asset;
    this.zoomSizeImageUrl$ = this.assetUrlService.getZoomImageUrl$(this.asset);
  }
  get asset() {
    return this._asset;
  }
  private _asset!: AssetUIModel;

  /**
   * Enable zoom on the asset details page
   */
  enableZoom$ = this.activatedRoute.url.pipe(
    map((urlSegments) => {
      const assetRoutingPaths: string[] = Object.values(ImageZoomRoutingPaths);
      return urlSegments.some((urlSegment) => assetRoutingPaths.includes(urlSegment.path));
    }),
  );

  AssetTypes = CreateAssetDto.AssetTypeEnum;

  zoomSizeImageUrl$!: Observable<string>;

  constructor(
    private readonly assetUrlService: AssetsGenerateUrlService,
    private readonly activatedRoute: ActivatedRoute,
  ) {}
}
